import React, { useEffect, useRef, useState } from 'react';
import { Input } from 'react-frontier';
import { InputProps } from 'react-frontier/dist/Input';
import { Location } from '../SiteClasses';
import { formatPlacesComponents } from '../SiteUtil';
import { useMapsLibrary } from '@vis.gl/react-google-maps';

interface AutocompleteProps extends InputProps{
	onPlaceSelected?: (location: Location)=>void
	options?: google.maps.places.AutocompleteOptions,
	types?: string[],
}

const DEFAULT_OPTIONS = {
	types: ['address'],
	componentRestrictions: { country: 'MX' },
	fields: ['formatted_address', 'geometry', 'name', 'address_components', 'place_id'],
}

var Autocomplete = (props: AutocompleteProps)=>{
	var [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete>(null);
	var placeLibrary = useMapsLibrary('places');
	var inputRef = useRef<HTMLInputElement>(null);
	var {
		onPlaceSelected,
		options,
		types,
		...restProps
	} = props;

	useEffect(()=>{
		if(!placeLibrary || !inputRef.current) return;
		setAutocomplete(new placeLibrary.Autocomplete(inputRef.current, {
			...DEFAULT_OPTIONS,
			...(types != null ? { types } : {}),
			...props.options
		}));
	}, [placeLibrary]);

	useEffect(()=>{
		if(!autocomplete || !props.onPlaceSelected) return;
		autocomplete.addListener('place_changed', ()=>{
			var res = autocomplete.getPlace();
			var location = formatPlacesComponents(res);
			if(props.onPlaceSelected) props.onPlaceSelected(location);
		})
	}, [onPlaceSelected, autocomplete]);
	
	return <Input ref={inputRef} {...restProps} />
}

export default Autocomplete;